export enum IAARPersonStatus {
    SENT = "SENT",
    OPENED = "OPENED",
    COMPLETED = "COMPLETED"
}
